// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Eule": erscheint auf dem Ast, neigt den Kopf, streckt langsam einen Flügel.
export default function Eule() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      <g
        className="eule"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Ast */}
        <path d="M12 100 C40 96 80 96 108 100" />
        {/* Körper */}
        <path d="M40 96 C34 76 38 54 60 54 C82 54 86 76 80 96 Z" fill="var(--creme)" />
        {/* Flügel (streckt sich) */}
        <g className="eule-fluegel">
          <path d="M76 62 C88 68 90 80 86 92 C78 88 72 76 72 64 Z" fill="var(--salbei)" />
        </g>
        {/* Bauchgefieder */}
        <path d="M50 74 q4 4 8 0 q4 4 8 0 M54 84 q4 4 8 0" stroke="var(--salbei)" />
        {/* Kopf (neigt sich) */}
        <g className="eule-kopf">
          <path d="M38 40 C36 22 84 22 82 40 C84 52 76 58 60 58 C44 58 36 52 38 40 Z" fill="var(--creme)" />
          {/* Federohren */}
          <path d="M42 27 L38 16 M78 27 L82 16" />
          {/* Augen */}
          <circle cx="50" cy="40" r="7" fill="var(--salbei)" />
          <circle cx="70" cy="40" r="7" fill="var(--salbei)" />
          <circle cx="50" cy="40" r="2.5" fill="var(--tanne)" stroke="none" />
          <circle cx="70" cy="40" r="2.5" fill="var(--tanne)" stroke="none" />
          {/* Schnabel */}
          <path d="M57 47 L60 52 L63 47 Z" fill="var(--sand)" />
        </g>
        {/* Krallen */}
        <path d="M52 96 L52 101 M58 96 L58 101 M66 96 L66 101" />
      </g>
    </svg>
  )
}
